import { Components, Theme } from '@mui/material';

export const MuiMenuStyle: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    elevation: 2,
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      border: `1px solid ${theme?.palette?.neutralGray6?.main ?? '#6A6E79'}`,
      marginTop: theme.spacing(0.5),
    }),
    list: ({ theme }) => ({
      padding: 0,
    }),
  },
};
